import Swiper from "swiper";

const state = {
  overlays: [],
  elements: {},
}

const cacheState = () => {
  state.elements = {
    overlaysContainer: document.querySelector('.hub-main__overlays'),
    overlaysWrapper: document.querySelector('.hub-main__overlays--wrapper'),
    closeBtn: document.querySelector('.hub-main__overlays--close'),
    titlesContainer: document.querySelector(".hub-main__overlays--list"),
    titlesContainerInner: document.querySelector(".hub-main__overlays--list .swiper-wrapper"),
  }

  const triggers = Array.from(document.querySelectorAll('[data-trigger-id]'));
  state.overlays = triggers.reduce(getOverlays, []);
}

const addEventListeners = () => {
  state.overlays.forEach(overlay => {
    overlay.triggers.forEach(trigger => trigger.addEventListener('click', (e) => {
      const isVideo = e.target.closest("video");
      const isImage = e.target.closest("img") || e.target.closest(".hub-main__media-wrapper");

      if (!isVideo && !isImage) return;

      onTriggerClick.bind(overlay)(e);
    }));
  })
  state.elements.closeBtn.addEventListener('click', () => toggleOverlay(false))
}

const getOverlays = (overlays, trigger) => {
  const { triggerId, title } = trigger.dataset;
  const triggerWithSameId = overlays.find(overlay => overlay.id === triggerId);
  if (triggerWithSameId) {
    triggerWithSameId.triggers.push(trigger)
    return overlays;
  }

  const componentEls = Array.from(document.querySelectorAll(`[data-overlay-id="${triggerId}"]`))
  if (!componentEls.length) return overlays;

  const components = componentEls.map(componentEl => {
    const wrapper = componentEl.closest('.shopify-section');
    return { componentEl, wrapper }
  })

  return [
    ...overlays,
    {
      triggers: [trigger],
      id: triggerId,
      title,
      components
    }
  ];
}

const moveOverlayComponents = () => {
  if (window.Shopify?.request?.designMode) return;
  state.overlays.forEach(overlay => {
    overlay.container = document.createElement('div');
    overlay.container.dataset.triggerId = overlay.id;
    overlay.container.className = "hub-main__overlay-item";
    overlay.components.forEach((component) => {
      overlay.container.appendChild(component.componentEl)
    })

    state.elements.overlaysWrapper.appendChild(overlay.container);
  })
}

function onTriggerClick(e) {
  if (e.target.classList.contains("hub-main__cta")) return;
  const id = this.id;
  state.overlays.forEach(overlay => {
    overlay.container.classList.remove('active');
    overlay.titleEl?.classList.remove('active')
  });
  this.container.classList.add('active');
  state.titlesSwiper.slideTo(this.titleEl.dataset.index);
  this.titleEl.classList.add('active')
  toggleOverlay(true);

  document.dispatchEvent(
    new CustomEvent('overlay:open', {
      detail: { id },
    })
  );
}

const toggleOverlay = (force, id) => {
  document.body.classList.toggle('overflow-hidden', force)
  state.elements.overlaysContainer.classList.toggle('active', force);

  document.dispatchEvent(
    new CustomEvent(`overlay:${force ? "open" : "close"}`, {
      detail: { id },
    })
  );
}

const addOverlayTitles = () => {
  let index = 0;
  state.overlays.forEach(overlay => {
    if (!overlay.title) return;
    overlay.titleEl = document.createElement('div');
    overlay.titleEl.classList = "swiper-slide";
    overlay.titleEl.dataset.index = index;
    overlay.titleEl.textContent = overlay.title;
    overlay.titleEl.addEventListener('click', onTriggerClick.bind(overlay));
    state.elements.titlesContainerInner.insertAdjacentElement('beforeend', overlay.titleEl)

    index += 1;
  })
}

const initTitlesSwiper = () => {
  state.titlesSwiper = new Swiper(state.elements.titlesContainer, {
    spaceBetween: 15,
    centeredSlides: true,
    centeredSlidesBounds: true,
    slidesPerView: "auto",
    slideToClickedSlide: true,
  })
}

const init = () => {
  cacheState();
  moveOverlayComponents();
  addOverlayTitles();
  initTitlesSwiper();
  addEventListeners();
}

export default init;
